import React from 'react';
import { Box } from '@mui/material';
import { stockStatusType, TransferType } from '../Stocks/stock.helper';
import { grnReceivedTabsDetails } from '../GRN/Received/ReceivedHelper';
import { ProspectiveTabsDetails } from '../GRN/Prospective/ProspectiveHelper';
import { DocumentType } from '../../Configuration/InventoryApproval/inventoryApproval.types';

export type PRStatusChipType = 'indent_approve';

interface SelectedChipProps {
  value:  TransferType | stockStatusType | grnReceivedTabsDetails | ProspectiveTabsDetails | PRStatusChipType | DocumentType; 
  label: string;
}

const StockStatusChip: React.FC<SelectedChipProps> = (data) => {

  const statusStyles: Record<string, { color: string; bgColor: string }> = {
    Stock: { color: '#4B6BFB', bgColor: '#F2F7FF' },
    GRN: { color: '#E1CF32', bgColor: '#FFFBDC' },
    Received: { color: '#47B35F', bgColor: '#EDFFF1' },
    Quantity_Adjustment: { color: '#F58634', bgColor: '#FFF9F4' },
    Low_Stock: { color: '#B4B4B4', bgColor: '#F7F7F7' },
    No_Stock: { color: '#9B3434', bgColor: '#FFEFEF' },
    Near_Expiry: { color: '#53719A', bgColor: '#F2F7FF' },
    Expired: { color: '#D32F2F', bgColor: '#FFEBEE' },
    draft: { color: '#9E9E9E', bgColor: '#F7F7F7' },
    pending: { color: '#EFAE78', bgColor: '#FBF7F3' },
    approved: { color: '#47B35F', bgColor: '#F4FFF6' },
    rejected: { color: '#F25B5B', bgColor: '#FBF2F2' },
    new: { color: '#3A80E2', bgColor: '#F2F6FB' },
    indent_approve: { color: '#EFAE78', bgColor: '#FFF7F1' },
    purchase_order: { color: '#3A80E2', bgColor: '#F2F7FF' },
    grn_return: { color: '#EFAE78', bgColor: '#FAF0E8' },
    grn: { color: '#47B35F', bgColor: '#F4FFF6' },
  };

  // Normalize status value for lookup (handle case variations)
  const normalizeStatus = (status: string): string => {
    // Convert to title case with underscore (e.g., QUANTITY_ADJUSTMENT -> Quantity_Adjustment)
    return status
      .toLowerCase()
      .split('_')
      .map((word, index) => index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word.charAt(0).toUpperCase() + word.slice(1))
      .join('_');
  };

  const normalizedValue = normalizeStatus(String(data.value));
  const { color, bgColor } = statusStyles[normalizedValue] || statusStyles[data.value] || { color: '#000', bgColor: '#FFF' }; // Default styles

  const chipSx = {
    // border: `1px solid ${color}`,
    backgroundColor: bgColor,
    borderRadius: '100px',
    padding: '4px 10px',
    color: color,
    fontWeight: 600,
    fontSize: 13,
    width: 'fit-content',
    textTransform: 'capitalize' as const, // optional: keeps consistent look
  };

  return <Box sx={chipSx}>{data.label}</Box>;
};

export default StockStatusChip;
